import { useTranslation } from "react-i18next";
import { createStyles } from "antd-style";

import { useJobLocationParts } from "@av/apps/recruitment/ats-common/services/job-posts/hooks/useJobLocationParts";
import type { Province } from "@av/apps/recruitment/ats-common/types";
import { Typography } from "@av/components/atoms/typography/Typography";

const { Text } = Typography;

const useStyles = createStyles(({ css }) => ({
  address: css`
    min-width: 0;
    overflow-wrap: anywhere;
  `,
}));

type JobPostAddressProps = {
  city?: string;
  streetAddress?: string;
  subdivisionCode?: Province;
  testIdPrefix: string;
};

export function JobPostAddress({
  city,
  streetAddress,
  subdivisionCode,
  testIdPrefix,
}: JobPostAddressProps) {
  const { styles } = useStyles();
  const { t } = useTranslation();
  const { fullText: address, streetAddressPart } = useJobLocationParts(city, subdivisionCode, {
    streetAddress,
  });

  if (!streetAddressPart || !address) {
    return null;
  }

  return (
    <Text type="secondary" className={styles.address} testIdPrefix={`${testIdPrefix}-address`}>
      {t("recruitment.jobs.addJob_positionDetails_locationAddress", { address })}
    </Text>
  );
}
